import { marked } from "marked";
import { LocationMarkerPlugin } from "./markerPlugin";
import { Editor } from '@tiptap/vue-3';

export function feedMarkdown(token) {

  const streamingNode = document.querySelector('.streaming-node');
  if (!streamingNode) {
    return;
  }

  let buffer = streamingNode.querySelector('.streaming-node-buffer') as HTMLElement;
  let parsed = streamingNode.querySelector('.streaming-node-parsed');

  if (!buffer || !parsed) {
    streamingNode.innerHTML = `
      <div class="streaming-node-parsed"></div>
      <div class="streaming-node-buffer"></div>
      <div class="streaming-node-result"></div>
    `
    buffer = streamingNode.querySelector('.streaming-node-buffer') as HTMLElement;
    parsed = streamingNode.querySelector('.streaming-node-parsed');      
  }

  buffer.innerHTML += token
  if (!buffer.dataset.orig) {
    buffer.dataset.orig = ''
  }
  buffer.dataset.orig += token

  const text = buffer.dataset.orig

  const parts = getHealablePortion(text)
  if (parts) {
    const [toHeal, toKeep] = parts
    const formatted = marked(toHeal) as string
    buffer.innerHTML = toKeep
    parsed.innerHTML += formatted
    buffer.dataset.orig = toKeep
  }

  
}

export function finalMarkdown(text) {
  const streamingNode = document.querySelector('.streaming-node');
  if (!streamingNode) {
    return;
  }

  let buffer = streamingNode.querySelector('.streaming-node-buffer') as HTMLElement;
  let parsed = streamingNode.querySelector('.streaming-node-parsed') as HTMLElement;
  let result = streamingNode.querySelector('.streaming-node-result') as HTMLElement;
  if (result) result.innerHTML = marked(text) as string; 
  if (parsed) parsed.innerHTML = '';
  if (buffer) buffer.innerHTML = '';
}

export function markdownAutoHeal(editor: Editor, from) {

  const control = {
    canceled: false
  }

  let ptr = from

  const handle = setInterval(()=> {

    let decor;
    const decorSet = (LocationMarkerPlugin.props as any).decorations(editor.state)
    if (decorSet) {
      const decors = decorSet.find()
      if (decors.length > 0) {
        decor = decors[0]
      }
    }
    if (!decor || decor.to < ptr) {
      clearInterval(handle)
      return
    } 
    const to = decor.to

    const possibleTextToHeal = editor.state.doc.textBetween(ptr, to)

    const healPortion = getHealablePortion(possibleTextToHeal)

    const formatted = marked(healPortion) as string

    editor.chain()
      .deleteRange(          
        { from: ptr, to: healPortion.length }
      )    
      .run()

    editor.chain().insertContent(formatted).run()

    ptr += formatted.length
    
    if (control.canceled) {
      clearInterval(handle)
    }

  }, 500)


}

const getHealablePortion = (text) => {
  const lines = text.split('\n');
  let lastEmptyLineIndex = -1;

  for (let i = lines.length - 1; i >= 0; i--) {
    if (lines[i].trim() === '') {
      lastEmptyLineIndex = i;
      break;
    }
  }

  if (lastEmptyLineIndex === -1) {
    return null;
  }
  return [
    lines.slice(0, lastEmptyLineIndex).join('\n'),
    lines.slice(lastEmptyLineIndex, lines.length).join('\n')
  ]
};